import { defaultCabinClass } from "@/schemas/passengerSchema";

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

// Ferry passenger types: adult, young, child
const defaultFerryPassengerCounts = {
  adult: 1,
  young: 0,
  child: 0,
  childAges: [],
  isWithVehicle: false,
  vehicleType: null,
  ticketCount: 1,
};

// Ferry için initial state - sadece gerekli alanlar
export const initialState = {
  loading: false,
  departureDate: tomorrow,
  returnDate: null,
  departureCity: null,
  returnCity: null,
  passengers: defaultFerryPassengerCounts,
  tempPassengers: defaultFerryPassengerCounts,
  cabinClass: defaultCabinClass, // Ferry için de cabin class var (normal, vip vb.)
  latestFerrySearches: null,
  popularCities: null,
  publicHolidays: [],
  activeTab: "oneway",
  isCouponSale: false,
  ferryVehicles: [],
};

export const ferrySearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DEPARTURE_DATE":
      return { ...state, departureDate: action.payload };
    case "SET_RETURN_DATE":
      return { ...state, returnDate: action.payload };
    case "SET_DEPARTURE_CITY":
      return { ...state, departureCity: action.payload };
    case "SET_RETURN_CITY":
      return { ...state, returnCity: action.payload };
    case "TOGGLE_DEPARTURE_AND_RETURN":
      return {
        ...state,
        departureCity: state.returnCity,
        returnCity: state.departureCity,
      };
    case "SET_PASSENGERS_AND_CABIN_CLASS":
      return {
        ...state,
        passengers: action.payload.passengers,
        cabinClass: action.payload.cabinClass,
      };
    case "SET_LATEST_FLIGHT_SEARCHES": // Backward compatibility için
    case "SET_LATEST_FERRY_SEARCHES":
      return { ...state, latestFerrySearches: action.payload };
    case "SET_POPULAR_CITIES":
      return { ...state, popularCities: action.payload };
    case "SET_PUBLIC_HOLIDAYS":
      return { ...state, publicHolidays: action.payload };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_PASSENGERS":
      return {
        ...state,
        passengers: { ...state.passengers, ...action.payload },
      };
    case "SET_IS_WITH_VEHICLE":
      return {
        ...state,
        passengers: { ...state.passengers, isWithVehicle: action.payload },
      };
    case "SET_VEHICLE_TYPE":
      return {
        ...state,
        passengers: { ...state.passengers, vehicleType: action.payload },
      };
    case "SET_CHILD_AGES":
      return {
        ...state,
        passengers: { ...state.passengers, childAges: action.payload },
      };
    case "SET_TEMP_PASSENGERS":
      return {
        ...state,
        tempPassengers: { ...state.tempPassengers, ...action.payload },
      };
    case "SET_IS_COUPON_SALE":
      return { ...state, isCouponSale: action.payload };
    case "SET_TICKET_COUNT":
      return {
        ...state,
        passengers: { ...state.passengers, ticketCount: action.payload },
      };
    case "SET_FERRY_VEHICLES":
      return { ...state, ferryVehicles: action.payload };
    default:
      return state;
  }
};

export default ferrySearchReducer;
